import * as handlers from './handlers';

const iosBridgeMiddleware = store => next => (action) => {
  next(action);
  const state = store.getState();

  handlers.handlePairing(state, action, store.dispatch);
  handlers.handleTipping(state, action, store.dispatch);
  handlers.handleReaderTransactions(state, action, store.dispatch);
  handlers.handleReceipt(state, action, store.dispatch);
  handlers.handleHandoff(state, action, store.dispatch);
  handlers.handleChangeShop(state, action);
  handlers.handleCashDrawer(state, action);
  handlers.handleLogout(action);
  handlers.handleMessages(action, store.dispatch);
  handlers.handleWebreaderProcessor(state, action, store.dispatch);
};

export default iosBridgeMiddleware;
